var __jsx = React.createElement;
import React, { Fragment } from 'react';
import styled from 'styled-components';
import styles from './StaffBioDetail.style';
import RichText from '../../atoms/RichText/RichText';
import Heading from '../../atoms/Heading';
import Image from '../../atoms/Image';
import Para from '../../atoms/Para';
import List from '../../molecules/List';
import ListItem from '../../molecules/List/ListItem';
import SocialIcons from '../../molecules/SocialIcons';
import { socialURLs, staffBioAccreditationsSwitch } from '../../../constants/globalConstants';
import { staffLabels } from '../../../constants/labels/en/';
import uuidv1 from 'uuid/v1';
import { imageRenditions } from './config';
var StaffBioDetail = function StaffBioDetail(_ref) {
  var staffBioDetailData = _ref.staffBioDetailData,
    className = _ref.className,
    locationName = _ref.locationName;
  var staffName = staffBioDetailData.staffName,
    title = staffBioDetailData.title,
    longBio = staffBioDetailData.longBio,
    staffImage = staffBioDetailData.staffImage,
    accreditation = staffBioDetailData.accreditation,
    facebookUrl = staffBioDetailData.facebookUrl,
    twitterUrl = staffBioDetailData.twitterUrl,
    linkedInUrl = staffBioDetailData.linkedInUrl,
    youTubeUrl = staffBioDetailData.youTubeUrl,
    instagramUrl = staffBioDetailData.instagramUrl;
  var socialMediaLinks = {};
  socialMediaLinks[socialURLs.TWITTER] = twitterUrl;
  socialMediaLinks[socialURLs.FACEBOOK] = facebookUrl;
  socialMediaLinks[socialURLs.INSTAGRAM] = instagramUrl;
  socialMediaLinks[socialURLs.YOUTUBE] = youTubeUrl;
  socialMediaLinks[socialURLs.LINKEDIN] = linkedInUrl;
  var richTextEmbeddedAsset = longBio && longBio.links && longBio.links.assets.block || [];
  return __jsx("div", {
    className: "nva-staff-bio-detail ".concat(className)
  }, __jsx("div", {
    className: "row"
  }, __jsx("div", {
    className: "title-detail col-xs-12 col-md-offset-1 col-md-6 col-lg-5 col-lg-offset-1 mobile-only"
  }, title && __jsx(Heading, {
    HeadingType: "h4",
    className: "nva-staff-bio-detail__title staff-title"
  }, title), staffName && __jsx(Heading, {
    HeadingType: "h1",
    className: "nva-staff-bio-detail__name staff-name"
  }, staffName)), __jsx("div", {
    className: "image-detail col-xs-12 col-md-offset-1 col-md-5 col-lg-4 col-lg-offset-1"
  }, staffImage && staffImage.image && __jsx("div", {
    className: "nva-staff-bio-detail__image staff-image"
  }, __jsx(Image, {
    src: staffImage.image.url,
    alt: staffImage.altText,
    title: staffImage.title || staffImage.altText,
    srcSetSettingImg: {
      imageRenditions: imageRenditions
    }
  })), socialMediaLinks && __jsx("div", {
    className: "col-xs-12"
  }, __jsx(SocialIcons, {
    className: "nva-staff-bio-detail__social-icons",
    locationName: locationName,
    dataAnalyticsSocialLinks: true,
    socialIconsData: socialMediaLinks,
    styleType: "staff-social-link"
  }))), __jsx("div", {
    className: "bio-detail col-xs-12 col-md-offset-1 col-md-4 col-lg-4 col-lg-offset-1"
  }, title && __jsx(Heading, {
    HeadingType: "h4",
    className: "nva-staff-bio-detail__title staff-title desktop-only"
  }, title), staffName && __jsx(Heading, {
    HeadingType: "h1",
    className: "nva-staff-bio-detail__name staff-name desktop-only"
  }, staffName), longBio && longBio.json && __jsx(RichText, {
    ContainerElem: "div",
    jsonContent: longBio.json,
    richTextEmbeddedAsset: richTextEmbeddedAsset,
    className: "nva-staff-bio-detail__long-bio staff-detail col-xs-12"
  }), staffBioAccreditationsSwitch && accreditation && accreditation.length && __jsx(Fragment, null, __jsx(Heading, {
    HeadingType: "h2",
    className: "nva-staff-bio-detail__accreditation-heading accreditation-heading col-xs-12"
  }, staffLabels.ACCREDITATIONS), __jsx(List, {
    className: "nva-staff-bio-detail__accreditation-block accreditation-block col-xs-12 "
  }, accreditation.map(function (accreditationItem) {
    return __jsx(ListItem, {
      key: uuidv1()
    }, __jsx(Para, null, accreditationItem.accreditationName));
  }))))));
};
StaffBioDetail.defaultProps = {
  staffBladeData: '',
  inheritedstyles: {},
  className: ''
};
export default styled(StaffBioDetail).withConfig({
  componentId: "sc-vb5yq9-0"
})(["", ";"], styles);